import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRoundArrow = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M628.819 495.763v-76.352c0-42.739 57.25-64.348 90.646-34.095l243.318 220.418c20.671 18.73 20.671 48.983 0 67.711l-243.318 220.418c-33.396 30.252-90.646 9.123-90.646-33.614v-81.158c-265.047 0-450.582 76.835-583.106 244.909 53.010-240.105 212.039-480.212 583.106-528.234z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgRoundArrow);
export default ForwardRef;
